export default __webpack_public_path__ + "static/media/banner.be94cec1.jpg";